import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { Honeybadger } from '@honeybadger-io/react';
import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';

import App from './App';
import { UIContextProvider } from './lib/context/UIContext/UIContextProvider';

const honeyBadgerConfig = {
  apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY,
  environment: process.env.ENV,
  revision: process.env.REACT_APP_GIT_SHA,
  tags: 'frontend'
};

Honeybadger.configure(honeyBadgerConfig);

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <RecoilRoot>
      <RecoilNexus />
      <UIContextProvider>
        <App />
      </UIContextProvider>
    </RecoilRoot>
  </BrowserRouter>
);
